module.exports = __webpack_public_path__ + "static/media/outer_18.572e74a7.jpg";